/*!

=========================================================
* Argon Design System React - v1.1.2
=========================================================

* Product Page: https://www.creative-tim.com/product/argon-design-system-react
* Copyright 2023 Creative Tim (https://www.creative-tim.com)
* Licensed under MIT (https://github.com/creativetimofficial/argon-design-system-react/blob/master/LICENSE.md)

* Coded by Creative Tim

=========================================================

* The above copyright notice and this permission notice shall be included in all copies or substantial portions of the Software.

*/
import React, { useEffect, useRef, useState } from "react";

import { requestCheckout, requestPortal } from "../../services/userService"

// reactstrap components
import { Container, Row, Col, Card, CardBody, CardTitle, CardText, Button } from "reactstrap";


import { useNavigate } from "react-router-dom";
// core components
import DemoNavbar from "components/Navbars/DemoNavbar.js";
import MainFooter from "components/Footers/MainFooter.js";
import { useUserAuth } from "../../context/UserContext";
import { useLesson } from "../../hooks/lessonFramework";

const Subscriptions = () => {

  const [email, setEmail] = useState("");
  const [password, setPassword] = useState("");
  const [error, setError] = useState("");
  const mainRef = useRef(null);
  const navigate = useNavigate();
  const { setUser, user, logIn } = useUserAuth();




  const plans = [
    {
      name: "Basic",
      price: "$9/mo",
      features: ["Access to 10 lessons", "Basic support", "Community access"],
      buttonColor: "primary",
    },
    {
      name: "Pro",
      price: "$19/mo",
      features: ["Access to all lessons", "Priority support", "Certificate of completion"],
      buttonColor: "success",
    },
    {
      name: "Premium",
      price: "$29/mo",
      features: ["Everything in Pro", "1-on-1 mentorship", "Monthly webinars"],
      buttonColor: "warning",
    },
  ];



  const navigateCheckout = async () => {
    const responseURL = await requestCheckout(user.uid, user.email);
    // No URL when the backend fails or enrollment is closed — assigning
    // undefined would navigate to /undefined and bounce to the home page.
    if (!responseURL) return;
    window.location.href = responseURL;
  }



  return (
    <>
      <DemoNavbar />
      <main ref={mainRef}>
        <section className="border section section-shaped section-lg">
          <div className="shape shape-style-1 bg-gradient-default">
            <span />
            <span />
            <span />
            <span />
            <span />
            <span />
            <span />
            <span />
          </div>
          <Container className="pt-lg-7">

            <Row>

              <Col md="4" className="mb-4">
                <Card className="h-100 text-center shadow-sm">
                  <CardBody>
                    <CardTitle tag="h4">Basic</CardTitle>
                    <CardText className="display-5 my-3">$9/mo</CardText>
                    <ul className="list-unstyled mb-4">

                      <li >✅ Access to 10 lessons</li>
                      <li >✅ Basic support</li>
                      <li >✅ Community access</li>

                    </ul>
                    <Button color="primary" type="button" >Subscribe</Button>
                  </CardBody>
                </Card>
              </Col>



              <Col md="4" className="mb-4">
                <Card className="h-100 text-center shadow-sm">
                  <CardBody>
                    <CardTitle tag="h4">Pro</CardTitle>
                    <CardText className="display-5 my-3">$19/mo</CardText>
                    <ul className="list-unstyled mb-4">

                      <li >✅ Access to all lessons</li>
                      <li >✅ Priority support</li>
                      <li >✅ Certificate of completion</li>

                    </ul>
                    <Button color="success" onClick={navigateCheckout}>Subscribe</Button>
                  </CardBody>
                </Card>
              </Col>

            </Row>

            <Row>
              {plans.map((plan, index) => (
                <Col md="4" key={index} className="mb-4">
                  <Card className="h-100 text-center shadow-sm">
                    <CardBody>
                      <CardTitle tag="h4">{plan.name}</CardTitle>
                      <CardText className="display-5 my-3">{plan.price}</CardText>
                      <ul className="list-unstyled mb-4">
                        {plan.features.map((feature, idx) => (
                          <li key={idx}>✅ {feature}</li>
                        ))}
                      </ul>
                      <Button color={plan.buttonColor}>Subscribe</Button>
                    </CardBody>
                  </Card>
                </Col>
              ))}
            </Row>
          </Container>
        </section>
      </main>
      <MainFooter />
    </>
  );
};

export default Subscriptions;
